export const zeroPadding = (num: string, digits: number = 2) => {
  return ('0'.repeat(digits) + num).slice(-1 * digits)
}
